import { Component, Input, OnInit } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'tgt-input-icon',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, NgxMaskDirective],
  templateUrl: './input-icon.component.html',
  styleUrl: './input-icon.component.scss',
})
export class InputIconComponent implements OnInit {
  isFocused!: boolean;
  isSelect!: boolean;

  @Input() border_radios: boolean = false;
  @Input() error: boolean = false;
  @Input() type!: string;
  @Input() disabled!: boolean;
  @Input() icon!: string;
  @Input() placeholder: string = '';
  @Input() control: FormControl | AbstractControl = new FormControl('');
  @Input() mask: string = '';
  @Input() iconPosition: 'left' | 'right' = 'left';
  @Input() backGround: string = '';
  @Input() border!: boolean;

  validarValor() {
    if (this.control && this.control.value != '') {
      this.error = false;
    } else {
      this.error = true;
    }
  }

  limparControl(input: HTMLInputElement) {
    if (this.control && this.control.value) {
      this.control.setValue('');
    } else {
      if (this.type === 'date' || 'datetime' || 'datetime-local') {
        input.showPicker();
      }
    }
  }

  get formControl(): FormControl {
    return this.control as FormControl;
  }

  ngOnInit() {
    // Garantir que o controle está inicializado
    if (!this.control) {
      this.control = new FormControl('');
    }
  }
}
